// bootstrap.js
// This is the main file to import.
// ./jquery.js, ./tether.js, and must be included before the bootstrap package. Order is important.
import './jquery'
import './tether'
import './popper'

import 'bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css'


// WEBPACK FOOTER //
// ./src/include/bootstrap.js